import * as React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { formatDate } from '../../lib/formatDate';

interface Props {
    ordersTime: any[];
}

/** Change history of the production times, newest first (rendered inside a Panel). */
export default function OrdersTimeTable({ ordersTime }: Props) {
    return (
        <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader size="small" aria-label="Production time history">
                <TableHead>
                    <TableRow>
                        <TableCell>Updated</TableCell>
                        <TableCell align="right">Standard</TableCell>
                        <TableCell align="right">Expedited</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ordersTime.map((timeLine) => (
                        <TableRow key={timeLine.timestamp} hover>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(timeLine.timestamp, { time: true })}</TableCell>
                            <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{timeLine.standardProductionTime}</TableCell>
                            <TableCell align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{timeLine.expeditedProductionTime}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
